var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3569 13.9284C20.3569 15.3492 19.7925 16.7118 18.7878 17.7165C17.7831 18.7212 16.4205 19.2856 14.9997 19.2856C13.5789 19.2856 12.2163 18.7212 11.2116 17.7165C10.207 16.7118 9.64258 15.3492 9.64258 13.9284V6.42843C9.64258 5.00763 10.207 3.64502 11.2116 2.64036C12.2163 1.6357 13.5789 1.07129 14.9997 1.07129C16.4205 1.07129 17.7831 1.6357 18.7878 2.64036C19.7925 3.64502 20.3569 5.00763 20.3569 6.42843V13.9284Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7138 15C25.716 16.267 25.4681 17.5219 24.9843 18.6928C24.5005 19.8638 23.7903 20.9277 22.8945 21.8236C21.9986 22.7194 20.9347 23.4296 19.7637 23.9134C18.5928 24.3972 17.3378 24.6451 16.0709 24.6429H13.928C12.6609 24.6457 11.4057 24.3982 10.2345 23.9146C9.06334 23.431 7.99919 22.7208 7.10321 21.8248C6.20722 20.9288 5.49704 19.8647 5.01344 18.6935C4.52985 17.5223 4.28235 16.2671 4.28518 15M14.9995 24.6429V28.9286",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.5edaea2d40672351a6595373ef1aec0f.svg";
export { ForwardRef as ReactComponent };